import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Grid,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import { plantProtectionProducts } from "../../utils/newApi";
import theme from "../../components/theme/theme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import styles from "./ProductsToProtectPlantsScreen.styles";
import ProductsToProtectPlantsTable from "../../components/ProductsToProtectPlantsTable/ProductsToProtectPlantsTable";
import NewProductToProtectPlantsWindow from "../../components/ModalWindows/ProductsToProtectPlants/NewProductToProtectPlantsWindow";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import StyledFormTextField from "../../components/common/textFields/StyledFormTextField";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../components/common/pagination/TablePaginationActions";
import ListHeader from "../../components/common/ListHeader";

import { SERVER_ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const ProductsToProtectPlantsScreen = () => {
  const [plantsProducts, setPlantsProducts] = useState([]);
  const [plantsProductsCopy, setPlantsProductsCopy] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [page, setPage] = React.useState(
    localStorage.getItem("currentProductsToProtectPlantsPage")
      ? Number(localStorage.getItem("currentProductsToProtectPlantsPage"))
      : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    localStorage.getItem("currentProductsToProtectPlantsRowsPerPage")
      ? Number(
          localStorage.getItem("currentProductsToProtectPlantsRowsPerPage")
        )
      : 10
  );

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    plantProtectionProducts
      .getAllProducts()
      .then((res) => {
        const sorted = res.data.sort((a, b) => b.id - a.id);
        setPlantsProducts(sorted);
        setPlantsProductsCopy(sorted);
        setIsLoaded(true);
      })
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_DOWNLOAD_RESOURCES);
      });

    return () => {
      localStorage.setItem("currentPage", 0);
      localStorage.setItem("currentRowsPerPage", 10);
    };
  }, []);

  const handleChange = (e) => {
    if (e.target.value !== "") {
      const res = plantsProductsCopy.filter((product) => {
        return (
          product.name &&
          product.name.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
      });
      setPlantsProducts(res);
      setPage(0);
    } else {
      setPlantsProducts(plantsProductsCopy);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid container>
          <ListHeader
            variant="title-add-search"
            title="Lista środków ochrony roślin"
            handleAdd={() => setOpen(true)}
            searchComponent={
              <StyledFormTextField
                InputLabelProps={{ classes: { root: classes.label } }}
                name="name"
                fullWidth={matches}
                label="Szukaj produktu"
                variant="outlined"
                shrink="true"
                onChange={(e) => handleChange(e)}
              />
            }
          />
          <Grid container>
            <Grid item xs={12} align="center">
              <ProductsToProtectPlantsTable
                products={plantsProducts}
                setPlantsProducts={setPlantsProducts}
                plantsProductsCopy={plantsProductsCopy}
                handleError={handleError}
                page={page}
                rowsPerPage={rowsPerPage}
              />
              <TablePagination
                rowsPerPageOptions={[10, 15, 20, 50]}
                component="div"
                count={plantsProducts.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                classes={{
                  toolbar: classes.toolbar,
                  caption: classes.caption,
                }}
                ActionsComponent={TablePaginationActions}
                labelRowsPerPage={"Ilość wierszy na stronę"}
                labelDisplayedRows={({ from, to, count }) => {
                  return `${from}–${to} z ${
                    count !== -1 ? count : `więcej niż ${to}`
                  }`;
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
      <NewProductToProtectPlantsWindow
        isOpen={open}
        close={() => setOpen(false)}
        handleError={handleError}
      />
    </ThemeProvider>
  );
};

export default ProductsToProtectPlantsScreen;
